import {
  useQuery,
  UseQueryResult,
  UseQueryOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import { buildQueryString } from "@mimber-client/utils"
import type {
  AnnouncementWithRelationsDto,
  ResponseDto,
  QueryParamsDto,
} from "@mimber/schema"
import { announcementsKeys } from "../announcements.utils"

export type UseAnnouncementsParams = QueryParamsDto

export const useAnnouncements = (
  params?: UseAnnouncementsParams,
  options?: UseQueryOptions<ResponseDto<AnnouncementWithRelationsDto[]>, Error>
): UseQueryResult<ResponseDto<AnnouncementWithRelationsDto[]>, Error> => {
  guardAppUsage("mimber-organization", "useAnnouncements")

  const { server } = useServerContext()

  return useQuery({
    queryKey: announcementsKeys.findAll(params),
    queryFn: async () => {
      const response = await server.get<
        ResponseDto<AnnouncementWithRelationsDto[]>
      >(buildQueryString("announcements", params))
      return response.data
    },
    staleTime: 1 * 60 * 1000,
    ...options,
  })
}
